import React, { useEffect } from 'react'
import {
  track,
  identify,
  trackPage,
  resetSegmentIdentity,
  trackExperimentViewed,
  trackExperimentBucketed,
  adPartnersTo,
} from '@mc/track-event'
import { SegmentTrackingContext, TrackOptions } from '@mc/tracking-context'
import { useUser } from '../contexts/AuthContext'

const defaultIntegrations = adPartnersTo(false)

const wrappedTrack = (
  event: string,
  properties?: Record<
    string,
    string | number | boolean | object | null | undefined
  >,
  options?: TrackOptions,
) =>
  track(event, properties ?? {}, {
    integrations: options?.integrations ?? defaultIntegrations,
  })

const wrappedTrackPage = (
  event?: string,
  properties?: Record<string, unknown>,
  options?: TrackOptions,
) =>
  trackPage(
    event,
    { platform: 'web', ...properties },
    { integrations: options?.integrations ?? defaultIntegrations },
  )

export const SegmentTrackingProvider = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const { user, isLoading } = useUser()

  useEffect(() => {
    if (!isLoading && user?.analytics) {
      identify(user.analytics.userId, {
        email: user.email,
        user_id: user.analytics.userId,
      })
    } else if (!isLoading && !user) {
      resetSegmentIdentity()
    }
  }, [user, isLoading])

  return (
    <SegmentTrackingContext.Provider
      value={{
        identify,
        track: wrappedTrack,
        trackPage: wrappedTrackPage,
        resetSegmentIdentity,
        trackExperimentViewed,
        trackExperimentBucketed,
      }}
    >
      {children}
    </SegmentTrackingContext.Provider>
  )
}
